export enum EEventsUrls {
  EVENTS = 'events',
  CLASS = 'class',
  AGE_GROUP = 'age-group',
  CAPACITY = 'capacity',
  LANGUAGE = 'language',
  DATE_TIME = 'date-time',
  FACILITATOR = 'facilitator',
  CITIES = 'cities',
  LOCATION = 'location',
  LOCATION_ADDRESS = 'location-address',
  HOSTS = 'hosts',
  PLANNED_DATE = 'planned-date',
  HOSTED_PRIVATELY = 'hosted-privately',
  SHIPMENT_ADDRESS = 'shipment-address',
  SHIPMENT_LOCATION = 'shipment-location',
  SITE_COORDINATOR = 'site-coordinator',
  COORDINATOR = 'coordinator',
  FOOD_PROVIDED = 'food-provided',
  CHILDCARE_PROVIDED = 'childcare-provided',
  IDENTITY = 'identity',
  PHOTO = 'photo',
  GALLERY = 'gallery',
  PUBLISH = 'publish',
  REPUBLISH = 'republish',
  RESCHEDULE = 'reschedule',
  CANCEL = 'cancel',
  SESSION = 'session',
  SESSIONS = 'sessions',
  DESCRIPTION = 'description',
  TITLE = 'title',
  TYPE = 'type',
  URL = 'url',
  HOST = 'host',
  DUPLICATE = 'duplicate',
  MEETING_LINK = 'meeting-link',
  LOCATIONS = 'locations',
  CHILDCARE_COUNT = 'childcare-count',
  CHILDCARE = 'childcare',
  CUSTOM_QUESTION = 'custom-question',
  CLOSE = 'close',
  REGISTRANTS = 'registrants',
  PART = 'part',
  NOTES = 'notes',
  ORDERING = 'ordering',
  EVENT_PART = 'event-part',
  KIT_ORDERS = 'kit-orders',
  DATE = 'date',
  TIME = 'time',
  TIMEZONE = 'timezone',
  ATTENDANCE = 'attendance',
  ATTENDEES = 'attendees',
  EXPORT = 'export',
  REGISTRATION = 'registration',
}

export const editMeetingLinkUrl = `${EEventsUrls.EVENTS}/${EEventsUrls.MEETING_LINK}`;
export const eventLocationUrl = `${EEventsUrls.EVENTS}/${EEventsUrls.LOCATIONS}`;
export const editSessionDateTimeUrl = `${EEventsUrls.EVENTS}/${EEventsUrls.SESSION}/${EEventsUrls.DATE_TIME}`;

export const editPartDateUrl = `${EEventsUrls.EVENTS}/${EEventsUrls.PART}/${EEventsUrls.DATE}`;
export const editPartTimeUrl = `${EEventsUrls.EVENTS}/${EEventsUrls.PART}/${EEventsUrls.TIME}`;
export const editPartDateTimeUrl = `${EEventsUrls.EVENTS}/${EEventsUrls.PART}/${EEventsUrls.DATE_TIME}`;

export const eventCustomQuestionUrl = `${EEventsUrls.EVENTS}/${EEventsUrls.LOCATIONS}`;

export const eventPartKitOrdersUrl = `${EEventsUrls.EVENTS}-${EEventsUrls.ORDERING}/${EEventsUrls.EVENT_PART}/${EEventsUrls.KIT_ORDERS}`;
